<!--
📌 Componente: AlertNotifikation.vue
📂 Caminho: src/components/AlertNotifikation.vue
📝 Descrição: Componente global de notificações temporárias, com animação suave
    de entrada e saída, exibido no canto superior da tela.

👁️ Interface e Interação com o Usuário:
  - Aparece no canto superior central e desaparece automaticamente.
  - Personalização de mensagem, cor de fundo e duração.
  - Animação suave para entrada e saída.

📥 Entrada (Props):
  - `message` (String, obrigatório) - Texto da notificação.
  - `color` (String, opcional) - Token de cor de tailwind.config.js (padrão:
    "verde-suave"). Aceitos: verde-suave, verde-profundo, vermelho-suave,
    vermelho-profundo, amarelo-dourado, amarelo-profundo, azul-profundo.
    Valor desconhecido cai em azul-profundo (neutro) e avisa no console.
  - `duration` (Number, opcional) - Tempo de exibição em ms (padrão: 3000).

📤 Saída (Emits): Nenhum.

💡 Exemplo de Uso:
  inject: ["showNotification"]
  this.showNotification("Produto salvo com sucesso!", "amarelo-dourado", 5000)

🔗 Dependências: Nenhuma externa (usa TailwindCSS para estilização).
-->

<template>
  <transition name="fade">
    <div
      v-if="visible"
      class="fixed top-5 left-1/2 transform -translate-x-1/2 px-6 py-3 rounded shadow-lg text-center max-w-xs"
      :class="estiloCor"
    >
      {{ message }}
    </div>
  </transition>
</template>

<script>
// Classes por token: a cor vem só de tailwind.config.js. O texto acompanha o
// fundo para manter contraste (texto escuro sobre o amarelo claro).
const ESTILO_POR_COR = Object.freeze({
  "verde-suave": "bg-verde-suave text-branco",
  "verde-profundo": "bg-verde-profundo text-branco",
  "vermelho-suave": "bg-vermelho-suave text-branco",
  "vermelho-profundo": "bg-vermelho-profundo text-branco",
  "amarelo-dourado": "bg-amarelo-dourado text-texto-principal",
  "amarelo-profundo": "bg-amarelo-profundo text-branco",
  "azul-profundo": "bg-azul-profundo text-branco",
});

export default {
  props: {
    message: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: "verde-suave", // Sucesso
    },
    duration: {
      type: Number,
      default: 3000, // Tempo padrão de 3 segundos
    },
  },
  data() {
    return {
      visible: true,
    };
  },
  computed: {
    estiloCor() {
      const estilo = ESTILO_POR_COR[this.color];
      if (!estilo) {
        console.warn(
          `AlertNotifikation: token de cor desconhecido "${this.color}".`
        );
        return ESTILO_POR_COR["azul-profundo"];
      }
      return estilo;
    },
  },
  mounted() {
    setTimeout(() => {
      this.visible = false;
    }, this.duration);
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.fixed {
  z-index: 99;
}
</style>
